import { FbmakeStyles } from "@flexibees/core";
import { COLORS } from "../constants/colors";

// Shared Common Styles
const commonStyles = (theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  contentHeader: {
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
  },
  textTransform_none: {
    textTransform: "none",
    padding: 0,
  },
  tags: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "5px 0",
  },
  addConfigButton: {
    marginRight: 20,
  },
  marginTop_25: {
    marginTop: 10,
  },
  marginRight_20: {
    marginRight: 20,
  },
  tableContainer: {},
  marginHorizontal_20: {
    marginLeft: 20,
    marginRight: 20,
  },
  spacing: {
    marginRight: 20,
    width: 200,
    textTransform: "none",
  },
  skillToolTipBox: {
    borderRadius: 0,
    margin: theme.spacing(1),
    borderWidth: 0,
  },
  skillslist: {
    maxHeight: 200,
    overflow: "auto",
  },
  linkButton: {
    color: COLORS.LINK,
    fontWeight: "500",
    fontSize: 13,
    textDecoration: "underline",
    marginRight: 10,
    cursor: "pointer",
  },
  rowTitle: {
    color: COLORS.SUBTEXT,
  },
});

const commonDialogStyles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  button: {
    width: "100%",
    padding: 10,
  },
});

// useStyles
export const useStyles = FbmakeStyles((theme) => ({
  ...commonStyles(theme),
  contentBody: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    width: "70vw",
  },
}));

// useListStyles
export const useListStyles = FbmakeStyles((theme) => ({
  ...commonStyles(theme),
  contentBody: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    width: "70vw",
    marginTop: 24,
  },
}));

// useStylesForm
export const useStylesForm = FbmakeStyles((theme) => ({
  ...commonDialogStyles(theme),
  root: {
    ...commonDialogStyles(theme).root,
    width: 560,
  },
  row: {
    marginBottom: 20,
  },
}));

// useConfigStyle
export const useConfigStyle = FbmakeStyles((theme) => ({
  ...commonStyles(theme),
  contentBody: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
  },
  tags: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  subtextColor: {
    color: COLORS.SUBTEXT,
  },
  marginTop_25: {
    marginTop: 25,
  },
}));

// useAddActivity
export const useAddActivity = FbmakeStyles((theme) => ({
  ...commonDialogStyles(theme),
  root: {
    ...commonDialogStyles(theme).root,
    width: 560,
  },
  row: {
    marginBottom: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  dropdownContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    marginBottom: 20,
  },
  addMoreSessions: {
    width: "10%",
    display: "inline-block",
    textAlign: "center",
    marginLeft: 10,
  },
}));

// useDialog
export const useDialog = FbmakeStyles((theme) => ({
  ...commonDialogStyles(theme),
  root: {
    ...commonDialogStyles(theme).root,
    padding: theme.spacing(5),
    width: 380,
  },
  image: {
    width: "50%",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
}));

// useAvalibiltyStyle
export const useAvalibiltyStyle = FbmakeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  contentBody: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  textTransform_none: {
    textTransform: "none",
    padding: 0,
  },
  tags: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "5px 0",
    width: "auto",
  },
  spacing: {
    marginRight: 20,
    width: 200,
    textTransform: "none",
  },
  skillToolTipBox: {
    padding: 10,
    border: "none",
    textAlign: "left",
  },
}));